import React from 'react';
import {Link} from "react-router-dom";
import "./TopMenu.scss";

function TopMenu() {
    const contactForm = "1247612b-27c2-424f-82ae-a15fdff5a08b";

    return (
        <div className="top-menu">
            <Link to={{pathname: `/`}}>Scripts</Link>
            <Link to={{pathname: `/info`}}>Info</Link>
            {contactForm ? <Link to={{pathname: `/contact`}}>Contact</Link> : null}
            <a className="subscribe" href="https://www.youtube.com/@EnvixityScripts_YT" target="_blank" rel="noreferrer">Subscribe</a>
        </div>
    );
}

export default TopMenu;
